import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

class HeaderNavigationService {
    constructor() {
        this._navigationState = new BehaviorSubject(false);
    }
    get navigationState() {
        return this._navigationState.asObservable();
    }
    registerNavigationTrigger(element) {
        this.navigationTrigger = element;
    }
    registerNavigationContainer(element) {
        this.navigationContainer = element;
    }
    focusNavigationTrigger() {
        this.navigationTrigger?.focus();
    }
    focusNavigationContainer() {
        this.navigationContainer?.focus();
    }
    toggleNavigation() {
        this._navigationState.next(!this._navigationState.value);
    }
}
HeaderNavigationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: HeaderNavigationService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
HeaderNavigationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: HeaderNavigationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.0", ngImport: i0, type: HeaderNavigationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { HeaderNavigationService };
